// extracted by mini-css-extract-plugin
export var root = "HuntEmbeded-module--root--02f57";